let currentIndex = 1; // Initially, the center watch is at index 1
let selectedWatch = undefined
let hoveredWatch = undefined
let disableUnselect = false

function changeWatch(direction) {
    currentIndex += direction;

    if (currentIndex < 0) {
        currentIndex = 2;
    } else if (currentIndex > 2) {
        currentIndex = 0;
    }    
    updateCarousel(direction);
}

function replaceClass(element,origin,target){
    element.classList.remove(origin);    
    element.classList.add(target)    
}

function mouseListener() {  
  if(!disableUnselect){            
    selectedWatch.classList.toggle('watch-active')        
    selectedWatch = undefined
    //hoveredWatch.querySelector('h2').classList.toggle('watch-hovered')
    //centerText(hoveredWatch)
    document.removeEventListener('mousemove',mouseListener)    
  }
}

function centerText(element){
  const textWidth = element.querySelector('h2').offsetWidth    
  const center = (element.offsetWidth/2)-(textWidth/2)-50       
  element.querySelector('h2').style.transform = `translate(${center}px,-10px)`
}
function uncenterText(element){
  const textWidth = element.querySelector('h2').offsetWidth    
  const center = (element.offsetWidth/2)-(textWidth/2)-50  
  element.querySelector('h2').style.transform = `translate(-${center}px,10px)`
}

function selectWatch(element) {    
    if(selectedWatch){
      selectedWatch.classList.toggle('watch-active')        
      selectedWatch = undefined
      element.classList.toggle('watch-hovered')
      //centerText(element)
    }
    selectedWatch = element.querySelector('.watch-name')
    disableUnselect = true    
    setTimeout(()=>{
      disableUnselect = false
    },500)
    document.addEventListener('mousemove', mouseListener)
    if (element.classList.contains('watch-right')) {         
      changeWatch(1);
    } else if (element.classList.contains('watch-left')) {           
      changeWatch(-1);
    }else{
        const anchor = element.querySelector('a')        
        window.location.href = anchor.href
    }    
  }
  function determineDirection(previousPosition,targetPosition) {
      const totalPositions = 3;      
      
      previousPosition = (previousPosition + totalPositions) % totalPositions;
      targetPosition = (targetPosition + totalPositions) % totalPositions;
    
      const distanceClockwise = (targetPosition - previousPosition + totalPositions) % totalPositions;
      const distanceCounterClockwise = (previousPosition - targetPosition + totalPositions) % totalPositions;

      return distanceClockwise <= distanceCounterClockwise ? 1 : -1;
  }
function selectCircleWatch(element) {
    if(currentIndex===element.tabIndex) return
    previousPosition=currentIndex
    currentIndex=element.tabIndex
    updateCarousel(determineDirection(previousPosition,element.tabIndex))            
  }

  function enterWatch(element) {    
    hoveredWatch = element
    if(disableUnselect) return    
    unselectAll()                
    //centerText(element)        
    //element.querySelector('h2').classList.add('watch-hovered')    
  }

  function leaveWatch(element) {     
    hoveredWatch = undefined      
    if(selectedWatch!==element.querySelector('h2')) {
     //uncenterText(element)
    }
    //element.querySelector('h2').classList.remove('watch-hovered')      
  }

  function unselectAll(){       
    selectedWatch=undefined
    const names = document.querySelectorAll('.watch-name')
    names.forEach(name=>{
      name.classList.remove('watch-active')
    })    
  }

function updateCarousel(direction) {
    const formerLeft= document.querySelector('.watch-left');
    const formerCenter= document.querySelector('.watch-center');
    const formerRight= document.querySelector('.watch-right'); 

    if(direction===-1){
        replaceClass(formerLeft,'watch-left','watch-center')
        replaceClass(formerCenter,'watch-center','watch-right')
        replaceClass(formerRight,'watch-right','watch-left')
    }
    if(direction===1){
        replaceClass(formerCenter,'watch-center','watch-left')
        replaceClass(formerRight,'watch-right','watch-center')
        replaceClass(formerLeft,'watch-left','watch-right')        
    }   
    
    if(selectedWatch){
      selectedWatch.classList.toggle('watch-active')          
    }

    //const dots = document.querySelectorAll('.kl-dot');

    // dots.forEach((dot, index) => {
    //     dot.classList.toggle('active', index === currentIndex);
    // });
}

function openingAnimation(){
  replaceClass(document.querySelector('.watch-left-initial'),'watch-left-initial','watch-left')
  replaceClass(document.querySelector('.watch-right-initial'),'watch-right-initial','watch-right')
}

// Initial setup
openingAnimation()
updateCarousel();
